<template>
  <GalleryModal
    :customStyle="customStyle"
    :dismissAction="dismissCreateGalleryModal"
    v-if="galleryActiveModal === 'CreateGalleryModal'">
    <template slot="header-title">
      <h4>สร้างแกลเลอรีใหม่</h4>
    </template>
    <template slot="body">
      <!-- ERROR CASE -->
      <div
        class="alert alert-danger"
        v-if="!createGalleryState.isCreated && createGalleryState.error">
        <p>
          มีข้อผิดพลาดเกิดขึ้นขณะสร้างแกลเลอรี <br>
          {{ createGalleryState.error }}
        </p>
      </div>
      <!-- SUCCESS CASE -->
      <div
        class="success-container"
        v-if="createGalleryState.isCreated">
        <h5><i class="fas fa-check"></i> สร้างแกลเลอรี "{{ currentGallery.title }}" สำเร็จ</h5>
        <button
          class="btn btn-primary"
          @click.stop="onEditGalleryClicked">
          เพิ่มรูปภาพในแกลเลอรี <i class="fas fa-arrow-alt-circle-right"></i>
        </button>
      </div>
      <!-- DEFAULT CASE -->
      <div
        class="body-container"
        v-if="!createGalleryState.isCreated">
        <FormGroup>
          <label for="galleryName">ชื่อแกลเลอรี</label>
          <input
            type="text"
            id="galleryName"
            class="form-control"
            placeholder="ตั้งชื่อแกลเลอรี"
            @keydown.enter.prevent="onCreateGalleryClicked"
            v-model="galleryName">
        </FormGroup>
        <FormGroup>
        <div class="row">
          <div class="col-md-12">
            <button
              class="btn btn-primary btn-create-gallery"
              @click.stop="onCreateGalleryClicked">
              <i class="fas fa-plus"></i> สร้างแกลเลอรีใหม่
            </button>
          </div>
        </div>
      </FormGroup>
      </div>
    </template>
  </GalleryModal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import FormGroup from '@/components/FormGroup.vue';
import GalleryModal from './GalleryModal.vue';

export default {
  data() {
    return {
      customStyle: {
        height: '240px',
      },
      galleryName: '',
    };
  },
  computed: {
    ...mapGetters([
      'createGalleryState',
      'currentGallery',
      'galleryActiveModal',
    ]),
  },
  components: {
    FormGroup,
    GalleryModal,
  },
  methods: {
    ...mapActions([
      'createGalleryByName',
      'dismissCreateGalleryModal',
      'loadAllGalleriesWithoutResetting',
    ]),
    async onCreateGalleryClicked() {
      if (this.galleryName.length === 0) {
        this.galleryName = 'Untitled Album';
      }
      await this.createGalleryByName(this.galleryName);
      await this.loadAllGalleriesWithoutResetting();
      this.galleryName = '';
    },
    onEditGalleryClicked() {
      this.$store.dispatch('setGalleryActiveModal', null);
      this.$router.push(`/galleries/${this.currentGallery.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-create-gallery {
  width: 100%;
}
.success-container {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  h5 {
    margin-bottom: 20px;
  }
}
</style>
